import PlayListsView from './PlayListsView';

export default PlayListsView;
